<template>
  <div class="invoice-header px-i pt-3 pt-md-4">
    <div v-if="merchantLogoUrl" class="invoice-header-logo">
      <img :src="merchantLogoUrl">
    </div>
    <div class="invoice-header-title">
      {{ documentTitle }}
    </div>
  </div>
</template>

<script>
export default {
  name: "MerchantLogo",

  props: {
    merchantLogoUrl: { type: String },
    documentTitle: { type: String }
  }
}
</script>
